import { render } from "./ConfirmationDialog.vue?vue&type=template&id=ac340022&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=ac340022&lang=scss&scoped=true"
import "./ConfirmationDialog.vue?vue&type=style&index=1&id=ac340022&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac340022"]])

export default __exports__